import React from 'react'
import styled from '@emotion/styled'
import { InsightCardContent, InsightCardWrapperProps } from 'src/components/insights/common/cards/card'
import { InsightCardLoadingBoundary } from 'src/components/insights/common/cards/card-loading-boundary'
import { Colors, Shapes } from 'src/components/theme'

type InsightCardSimpleProps = {
  children?: React.ReactNode
  errorTitle?: string
  errorMsg?: string
}

export const InsightCardImageWrapper = styled.div<InsightCardWrapperProps>`
  width: min-content;
  background-color: ${Colors.bgWhite};
  margin: ${Shapes.spacing[4]}px auto;
  border: 1px solid ${Colors.border};
  padding: ${Shapes.spacing[2]}px;
  border-radius: ${(props: InsightCardWrapperProps) =>
    props.isFooterOpen ? `${Shapes.borderRadius}px ${Shapes.borderRadius}px 0 0` : Shapes.borderRadius}px;
  overflow: hidden;
`

export const InsightCardImage: React.FC<InsightCardSimpleProps> = (props) => {
  const { children, errorTitle, errorMsg } = props

  return (
    <InsightCardImageWrapper>
      <InsightCardContent noPadding>
        <InsightCardLoadingBoundary title={errorTitle} message={errorMsg}>
          {children}
        </InsightCardLoadingBoundary>
      </InsightCardContent>
    </InsightCardImageWrapper>
  )
}
